import { AuthGuard } from 'authentication/guards/auth.guard';
import { ChannelDistributionStatusComponent } from 'exports/components/channel-distribution-status/channel-distribution-status.component';
import { ExportsMonitoringComponent } from 'exports/components/exports-monitoring/exports-monitoring.component';
import { ExportsComponent } from 'exports/components/exports/exports.component';
import { FullExportsComponent } from 'exports/components/full-exports/full-exports.component';
import { ImportsMonitoringComponent } from 'exports/components/imports-monitoring/imports-monitoring.component';
import { ImportsRunnerComponent } from 'exports/components/imports-runner/imports-runner.component';
import { ResourcePermissionsGuard } from 'shared/guards';
import { FeatureFlagEnum } from 'shared/interfaces/environment.interface';
import { getFeatureFlag } from 'shared/util/feature-flag.utils';

export const ExportsMonitoringRoutes = [
    {
        path: 'exports-monitoring',
        component: ExportsMonitoringComponent,
        canActivate: [ResourcePermissionsGuard],
        data: {
            header: {
                breadcrumbs: [
                    { label: 'breadcrumbs.exports.label', url: 'export-management', icon: 'folder-arrow-up' },
                    { label: 'breadcrumbs.exports.submenu.monitoring' },
                ],
            },
            pageTitle: ['breadcrumbs.exports.submenu.monitoring', 'breadcrumbs.exports.label'],
        },
    },
    {
        path: 'exports-monitoring/:channelId',
        component: ExportsMonitoringComponent,
        canActivate: [ResourcePermissionsGuard],
        data: {
            header: {
                breadcrumbs: [
                    { label: 'breadcrumbs.exports.label', url: 'export-management', icon: 'folder-arrow-up' },
                    { label: 'breadcrumbs.exports.submenu.monitoring' },
                ],
            },
            pageTitle: ['breadcrumbs.exports.submenu.monitoring', 'breadcrumbs.exports.label'],
        },
    },
];

export const ImportsMonitoringRoutes = [
    {
        path: 'imports-monitoring',
        component: ImportsMonitoringComponent,
        canActivate: [ResourcePermissionsGuard],
        data: {
            header: {
                breadcrumbs: [
                    { label: 'breadcrumbs.exports.label', url: 'export-management', icon: 'folder-arrow-up' },
                    { label: 'breadcrumbs.exports.submenu.monitoring' },
                ],
            },
            pageTitle: ['breadcrumbs.exports.submenu.monitoring', 'breadcrumbs.exports.label'],
        },
    },
    {
        path: 'imports-monitoring/:sourceId',
        component: ImportsMonitoringComponent,
        canActivate: [ResourcePermissionsGuard],
        data: {
            header: {
                breadcrumbs: [
                    { label: 'breadcrumbs.exports.label', url: 'export-management', icon: 'folder-arrow-up' },
                    { label: 'breadcrumbs.exports.submenu.monitoring' },
                ],
            },
            pageTitle: ['breadcrumbs.exports.submenu.monitoring', 'breadcrumbs.exports.label'],
        },
    },
];

export const ExportsRoutingConfig = [
    {
        path: 'export-management',
        component: ExportsComponent,
        canActivate: [AuthGuard, ResourcePermissionsGuard],
        children: [
            {
                path: 'channel-distribution-status',
                component: ChannelDistributionStatusComponent,
                canActivate: [ResourcePermissionsGuard],
                data: {
                    header: {
                        breadcrumbs: [
                            { label: 'breadcrumbs.exports.label', url: 'export-management', icon: 'folder-arrow-up' },
                            { label: 'breadcrumbs.exports.submenu.channelDistributionStatus' },
                        ],
                    },
                    pageTitle: ['breadcrumbs.exports.submenu.channelDistributionStatus', 'breadcrumbs.exports.label'],
                },
            },
            {
                path: 'full-export',
                component: FullExportsComponent,
                canActivate: [ResourcePermissionsGuard],
                data: {
                    header: {
                        breadcrumbs: [
                            { label: 'breadcrumbs.exports.label', url: 'export-management', icon: 'folder-arrow-up' },
                            { label: 'breadcrumbs.exports.submenu.fullExport' },
                        ],
                    },
                    pageTitle: ['breadcrumbs.exports.submenu.fullExport', 'breadcrumbs.exports.label'],
                },
            },
            {
                path: 'imports-runner',
                component: ImportsRunnerComponent,
                canActivate: [ResourcePermissionsGuard],
                data: {
                    header: {
                        breadcrumbs: [
                            { label: 'breadcrumbs.exports.label', url: 'export-management', icon: 'folder-arrow-up' },
                            { label: 'exports.imports-runner.label' },
                        ],
                    },
                    pageTitle: ['exports.imports-runner.label', 'breadcrumbs.exports.label'],
                },
            },
            ...(getFeatureFlag(FeatureFlagEnum.MONITORING_TAB) ? ExportsMonitoringRoutes : []),
            ...ImportsMonitoringRoutes,
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'channel-distribution-status',
            },
        ],
    },
];
